import { connect } from 'react-redux';
import { createSnack } from 'snackbar/snackbarSlice';
import Sidebar from './Sidebar';
import {
  fetchCarrierAuthorizations,
  fetchUniqueSelectors,
  getCurrentSelection,
  getSelectorsData,
  setCarrierAuthorizationsPending,
  setHeaderSubtitle,
  setSelectorsListPending,
} from '../store/carrierAuthorizationsSlice';
import { setFilters } from '../../filters/store/filtersSlice';

const mapState = state => ({
  cardsFetchError: state.loadingManagement.carrierAuthorizations.cardsFetchError,
  currentSelection: getCurrentSelection(state),
  searchTerm: state.loadingManagement.filters.searchTerm,
  selectedIndex: state.loadingManagement.filters.selectedIndex,
  selectorsFetchError: state.loadingManagement.carrierAuthorizations.selectorsFetchError,
  selectorsList: getSelectorsData(state),
  selectorsListPending: state.loadingManagement.carrierAuthorizations.selectorsListPending,
  submittingBatch: state.loadingManagement.createNewCarrierAuth.submittingBatch,
});

const mapDispatchToProps = {
  createSnack,
  fetchCarrierAuthorizations,
  fetchUniqueSelectors,
  setCarrierAuthorizationsPending,
  setFilters,
  setHeaderSubtitle,
  setSelectorsListPending,
};

export default connect(mapState, mapDispatchToProps)(Sidebar);
